import { dateFormat } from '../../../../helpers/timeHelper'

export const decodeRefiTransaction = (refi) => {
  if (!refi) {
    return null
  }

  return {
    ...refi,
    user: decodeRefiUser(refi.user),
    loan: decodeRefiLoan(refi.loan),
  }
}

function decodeRefiUser(refiUser) {
  if (!refiUser) {
    return null
  }

  return {
    ...refiUser,
    birthday: dateFormat(refiUser.birthday),
  }
}

function decodeRefiLoan(refiLoan) {
  if (!refiLoan) {
    return null
  }

  return {
    ...refiLoan,
    coApplicant: decodeLoanCoapplicant(refiLoan.coApplicant),
  }
}

function decodeLoanCoapplicant(loanCoApplicant) {
  if (!loanCoApplicant || !loanCoApplicant.user) {
    return null
  }

  return {
    ...loanCoApplicant.user,
    birthday: dateFormat(loanCoApplicant.user.birthday),
  }
}
